// Garage door colours & finishes — cropped from the official reference chart.
// Textures live at /garage-colors/gc-{index}.jpg (index = position + 1).
// Only the real RAL reference is shown (no internal codes).
export const GARAGE_COLORS = [
  { code: "", name: "Gris anthracite mat", ref: "RAL 7016", hex: "#3a4e53" },
  { code: "", name: "Blanc", ref: "RAL 9016", hex: "#f6fbfd" },
  { code: "", name: "Brun sépia mat", ref: "RAL 8014", hex: "#573e23" },
  { code: "", name: "Noir", ref: "RAL 9005", hex: "#1a1a1a" },
  { code: "", name: "Deep Mat anthracite (sablé)", ref: "RAL 7016", hex: "#5a6a6e" },
  { code: "", name: "Deep Mat quartz (sablé)", ref: "RAL 7039", hex: "#8f8d88" },
  { code: "", name: "Deep Mat noir sandgrain", ref: "RAL 9005", hex: "#1a1a1a" },
  { code: "", name: "Aluminium argenté mat", ref: "RAL 9006", hex: "#b3b4b7" },
];
